import React, { Component } from 'react';
import './App.css';
import  MyNav  from "./Components/Navbar/Navbar";
import  MyInput  from "./Components/Input/MyInput";
class App extends Component {
  render() {
    return (
      <div>
        <MyNav/>
        <MyInput/>
      </div>
    );
  }
}

export default App;
